import { TripPartEuropeMode } from 'app/constants/configuration/tripPartEuropeMode'

export const getTripPartEuropeModeName = (
  tripPartGenerationMode: TripPartEuropeMode,
  translate: (string) => string,
): string => {
  const text: string = TripPartEuropeMode[tripPartGenerationMode]
  return translate(`tripPartEuropeMode.${text}`)
}
